import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import { GoogleOAuthProvider } from '@react-oauth/google';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/index.css';
import './css/page.css';
import './css/pixigame.css';
import './css/lobby.css';
import './css/console.css';
import './css/footer.css';
import './css/popup.css';
import './css/profile.css';
import './css/room.css';
import './css/landingpage.css';
import './css/topbar.css';
import './css/colourPalette.css';
import './css/modalPopup.css';
import './css/privacyPolicy.css'
import './css/rulesCarcassonne.css'
import './css/loginPopup.css';
import './css/editUsernamePopup.css';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/react';

// Only initialize Sentry in production builds
if( process.env.NODE_ENV === 'production' )
{
  Sentry.init( {
    dsn: process.env.REACT_APP_SENTRY_DSN,

    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,

    environment: 'production',
  } );
}


const container = document.getElementById( 'root' );
const root = ReactDOM.createRoot( container );

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={ process.env.REACT_APP_GOOGLE_CLIENT_ID }>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
